module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/warsztaty-ehomaki-253fd308077538e87fff43b27b676328.jpg";